module.exports = __webpack_public_path__ + "static/media/history.52996457.svg";